import httpHelper from '../../../../utils/httpHelper';
const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));

export const service = {
  async getBeltSensorEventsByTransportationId(id, param) {
    const endPoint = `kv/belt-sensor-event/findAllByTransportationId/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
  async getLoadCellEventsByTransportationId(id, param) {
    const endPoint = `kv/load-cell-event/findAllByTransportationId/${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      param,
      'Bearer',
    );
    return result;
  },
  async getTransportationReportByTransportationId(id, params) {
    const endPoint = `kv/vehicle-safety-report/getTransportationReport?transportationId=${id}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params || {},
      'Bearer',
    );
    return result;
  },
};

export default service;
